import { MinimalistNavbar } from './MinimalistNavbar'

interface MinimalistLayoutProps {
  children: React.ReactNode
  backRoute?: string
  tooltipContent?: string
  classNameContainerChildren?: string
}

export const MinimalistLayout = ({
  children,
  backRoute,
  tooltipContent,
  classNameContainerChildren
}: MinimalistLayoutProps) => {
  return (
    <div className="flex flex-col">
      <main className="grid grid-cols-[1fr] grid-rows-[69px_1fr] h-screen justify-start transition-all duration-300 ease-in-out">
        <MinimalistNavbar
          backRoute={backRoute}
          tooltipContent={tooltipContent}
        />
        <div
          className={`${classNameContainerChildren} w-full flex col-span-full row-start-2 row-span-2 ui-kit-scrollbar overflow-y-auto h-[calc(100vh-69px)] overflow-x-hidden`}
        >
          {children}
        </div>
      </main>
    </div>
  )
}

export default MinimalistLayout
